// extracted by mini-css-extract-plugin
export default {"vendorsNav":"vendorsNav__YjQ1N","overlay":"overlay__NzMzN","active":"active__YmU1O"};